import React           from 'react';
import ReactDOM        from 'react-dom';
import UldBanner		from './app.jsx';

import './styles.scss';

export default class UldBannerModule {
	constructor(config) {
		const uldBannerEle = document.getElementById('uld-banner');
		if(uldBannerEle!=null){
			ReactDOM.render(React.createElement(UldBanner, config), uldBannerEle);
		}
	}
	static init(config) {
		return  new UldBannerModule(config);
	}	
}


// WEBPACK FOOTER //
// ./medscape_modules/uld/index.js